import {
  Injector,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { SmartEditLauncherService } from './services/smart-edit-launcher.service';
import { smartEditInterceptors } from './http-interceptors';
import { SmartEditService } from '../core';

export function smartEditFactory(injector: Injector): () => void {
  return () => {
    const smartEditLauncherService = injector.get(SmartEditLauncherService);
    if (smartEditLauncherService.isLaunchedInSmartEdit()) {
      const smartEditService = injector.get(SmartEditService);
      smartEditService.processCmsPage();
    }
  };
}

@NgModule({
  providers: [
    ...smartEditInterceptors,
    provideAppInitializer(() => {
      const initializerFn = smartEditFactory(inject(Injector));
      return initializerFn();
    }),
  ],
})
export class SmartEditRootModule {}
